import { useInfiniteQuery } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type { PlatformAuditListResponse } from '@/types/platform'

export const usePlatformAuditInfinite = (filters: {
  q?: string
  action?: string
  targetType?: string
  targetId?: string
  actorId?: string
  from?: string
  to?: string
}) => {
  return useInfiniteQuery({
    queryKey: ['platformAudit', filters],
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams()
      params.set('take', '30')
      if (pageParam) params.set('cursor', pageParam)
      if (filters.q) params.set('q', filters.q)
      if (filters.action) params.set('action', filters.action)
      if (filters.targetType) params.set('targetType', filters.targetType)
      if (filters.targetId) params.set('targetId', filters.targetId)
      if (filters.actorId) params.set('actorId', filters.actorId)
      if (filters.from) params.set('from', filters.from)
      if (filters.to) params.set('to', filters.to)

      const { data } = await apiClientPlatform.get<PlatformAuditListResponse>(
        `/platform/audit?${params.toString()}`
      )
      return data
    },
    getNextPageParam: (lastPage) =>
      lastPage.page.hasMore ? lastPage.page.nextCursor : null,
  })
}
